import gsap from 'gsap';

export const initExplosion = (navigate) => {





    document.querySelectorAll('.explosion').forEach(el => {
        if (el.dataset.explosionInit) return;
        el.dataset.explosionInit = 'true';

el.addEventListener('mouseenter', () => {
        console.log('--- mouseenter ---');
        console.log('offsetWidth:', el.offsetWidth);
        console.log('offsetHeight:', el.offsetHeight);
        console.log('computed clip-path:', getComputedStyle(el).clipPath);
        console.log('inline style:', el.getAttribute('style'));
        console.log('computed height:', getComputedStyle(el).height);
        console.log('computed transition:', getComputedStyle(el).transition);
    });



        el.addEventListener('click', (e) => {
            e.preventDefault();


            

            const url = el.href || el.closest('a')?.href;
            if (!url) return;

            const rect = el.getBoundingClientRect();
            const cx = rect.left + rect.width / 2;
            const cy = rect.top + rect.height / 2;

            const maxDist = Math.max(
                Math.hypot(cx, cy),
                Math.hypot(window.innerWidth - cx, cy),
                Math.hypot(cx, window.innerHeight - cy),
                Math.hypot(window.innerWidth - cx, window.innerHeight - cy)
            );

            const circle = document.createElement('div');
            circle.className = 'explosion-circle';
            circle.style.cssText = `
                position: fixed;
                top: ${cy}px;
                left: ${cx}px;
                width: 0px;
                height: 0px;
                border-radius: 50%;
                background: #0a0a0a;
                transform: translate(-50%, -50%);
                z-index: 9999;
                pointer-events: none;
            `;
            document.body.appendChild(circle);

            gsap.to(circle, {
                width: maxDist * 2,
                height: maxDist * 2,
                duration: 0.7,
                ease: 'power3.inOut',
                onComplete: () => navigate(url),
            });
        });
    });
};